import { jsx as _jsx } from "react/jsx-runtime";
import { DEFAULT_WIND_STRENGTH, DEFAULT_LAYERS, } from "@erikwatson/snowfall";
import { useDispatch } from "react-redux";
import { Control } from "../../../../control/control";
import { Range } from "../../../../range/range";
import { setWindStrength } from "../../../../../features/config/config.slice";
export const SnowflakeWindStrength = ({ index, layer, }) => {
    const dispatch = useDispatch();
    return (_jsx(Control, { name: "Strength", tooltip: "The strength of the wind", showOutput: true, reset: () => {
            const strength = index < DEFAULT_LAYERS.length ? DEFAULT_LAYERS[index].wind.strength : DEFAULT_WIND_STRENGTH;
            dispatch(setWindStrength({
                index,
                strength
            }));
        }, value: layer.wind.strength, onChange: (event) => dispatch(setWindStrength({
            index,
            strength: Number(event.target.value),
        })), children: _jsx(Range, { min: 0, max: 10, step: 1 }) }));
};
